import {
	CheckBadgeIcon,
	ClipboardDocumentCheckIcon,
	ExclamationTriangleIcon,
	XMarkIcon,
} from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Tooltip from "@/tooltip";
import { Actions as PENSIONACTIONS } from "../../store/actions/pensionActions";
import Spinner from "../common/Spinner";
import {addMonths, format} from "date-fns";
import AutoEnrolmentRow from "./AutoEnrolmentRow";

const AutoEnrolmentReassessmentModal = ({
	isModalOpen,
	showAutoEnrolmentBar,
	closeModal,
	openModal,
	autoEnrolmentDutiesStartDate,
	reassessmentEmployees,
	saveReassessmentEmployees,
	getReassessmentEmployees,
	reassessmentDate,
	allEmployeesHaveGroupId,
}) => {
	useEffect(() => {
		if (!reassessmentDate) {
            getReassessmentEmployees();
		}
	}, [autoEnrolmentDutiesStartDate]);

	if (showAutoEnrolmentBar && !isModalOpen)
		return (
			<div className="content bg-primary">
				<p
					className="font-w600"
					style={{ color: "#fff" }}
				>
					Your 3 year auto enrolment re-assessment has to be completed by{" "}
					{format(addMonths(new Date(reassessmentDate),3), "do MMMM yyyy")}.
				</p>
				<div
					className="btn btn-success pull-right mb-2"
					onClick={openModal}
				>
					<ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<div style={{ float: "left" }}>Re-assess your team now</div>
				</div>
				<div className="clearfix" />
			</div>
		);

	if (isModalOpen)
		return (
			<div
				className="modal"
				tabIndex="-1"
				role="dialog"
				aria-hidden="true"
				style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
			>
				<div
					className="modal-dialog"
					style={{ width: "75%" }}
				>
					<div className="modal-content">
						<div
							className="block block-themed block-transparent remove-margin-b"
							style={{ padding: 0 }}
						>
							<div
								className="block-header bg-primary-dark"
								style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
							>
								<ul className="block-options">
									<li>
										<button
											type="button"
											onClick={closeModal}
										>
											<XMarkIcon className="h-6 w-6 mr-3 text-white" />
										</button>
									</li>
								</ul>
								<h3 className="block-title">Employees to be re-enrolled</h3>
							</div>
							<div
								className="col-xs-12 pl-0"
								style={{ marginTop: "2rem", marginBottom: "2rem", background: "white" }}
							></div>
							<div
								className="col-xs-12"
								style={{ marginBottom: "2rem" }}
							>
								{ reassessmentEmployees?.length > 0 ?
									<table
										id="active-people-table"
										className="js-table-sections table table-hover"
									>
										<thead style={{ display: "table-header-group" }}>
											<tr>
												<th>NAME</th>
												<th>GROUP</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{reassessmentEmployees?.map((employee) => {
												return (
													<AutoEnrolmentRow
														key={employee.agreementId}
														employee={employee}
													/>
												);
											})}
										</tbody>
									</table>
									:
									<div
										className="text-center"
										style={{ padding: "2rem" }}
									>
										<ExclamationTriangleIcon
											style={{ height: "3em", color: "orange" }}
										/>
										<h3 className="block-title">No Employees to be re-enrolled</h3>
										<p>You may still need to write to the Pension Regulator to confirm you've completed your Cyclical Re-enrollment duties.</p>
									</div>
								}
							</div>
							<button
								className="btn btn-success pull-right mr-5 mb-5"
								onClick={() => {
									console.debug("reassessmentEmployees", reassessmentEmployees);
									saveReassessmentEmployees(reassessmentEmployees);
								}}
								disabled={!allEmployeesHaveGroupId}
							>
								<div style={{ float: "left" }}>{ reassessmentEmployees?.length > 0 ? `Apply` : `Confirm`}</div>
							</button>
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		);
};

const mapStateToProps = (state, ownProps) => {
	const reassessmentEmployees = state.pensions?.reassessmentEmployees;

	const reassessmentDate = state.pensions?.reassessmentDate;
	// show up to 3 months from now
	const maxDateToShow = reassessmentDate && format(addMonths(new Date(),3), "yyyy-MM-dd");
	const createdAt = state.company?.settings?.createdAt;

	// only show the modal if the company was created before the reassessment date and the reassessment date is before the max date to show
	const showAutoEnrolmentBar = reassessmentDate && createdAt < reassessmentDate && reassessmentDate < maxDateToShow;

	return {
		isModalOpen: state.pensions?.reassessmentModalStatus,
		showAutoEnrolmentBar,
		autoEnrolmentDutiesStartDate: state.company?.settings?.autoEnrolmentDutiesStartDate,
		reassessmentDate,
		reassessmentEmployees,
		allEmployeesHaveGroupId: reassessmentEmployees?.every((employee) => employee.groupId),
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(PENSIONACTIONS.showReassessmentModal(false)),
	openModal: () => dispatch(PENSIONACTIONS.showReassessmentModal(true)),
	getReassessmentEmployees: () => dispatch(PENSIONACTIONS.getReassessmentEmployees()),
	saveReassessmentEmployees: (data) => dispatch(PENSIONACTIONS.saveReassessmentEmployees(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoEnrolmentReassessmentModal);
